export const shouldShowConversationListFade = ({
  hiddenConvoCount = 0,
  hasExpanded = false,
} = {}) => Number(hiddenConvoCount) > 0 && !hasExpanded;
